export default __webpack_public_path__ + "static/media/copy.a4c05668.svg";